// tabsSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TabState {
  openFirstTimeOnlyPopup: any;
  applicationStatus: string;
  summaryPageActiveTab: string; // state is for tab from viewsummary page
  selectedIndex: number;
  productName: string;
  selectDisbDetailIndex: number;
  quickHelpInfoRoute: string;
  tabType: string; // Add tabType to state
  additionalSummaryActiveTab: number; // 0 = Documents, 1 = Consent
  additionalSummaryDocumentsComplete: boolean;
  additionalSummaryConsentComplete: boolean;
}

const initialState: TabState = {
  openFirstTimeOnlyPopup: {},
  applicationStatus: "",
  summaryPageActiveTab: "summary",
  selectedIndex: 0,
  productName: "",
  selectDisbDetailIndex: 0,
  quickHelpInfoRoute: "",
  tabType: "Term Loan", // Default value
  additionalSummaryActiveTab: 0,
  additionalSummaryDocumentsComplete: false,
  additionalSummaryConsentComplete: false,
};

const tabsSlice = createSlice({
  name: "tabs",
  initialState,
  reducers: {
    setOpenFirstTimeOnlyPopup: (state, action: PayloadAction<any>) => {
      state.openFirstTimeOnlyPopup = action.payload;
    },
    setApplicationStatus: (state, action: PayloadAction<string>) => {
      state.applicationStatus = action.payload;
    },
    setSummaryPageActiveTab: (state, action: PayloadAction<string>) => {
      state.summaryPageActiveTab = action.payload;
    },
    setSelectedIndex: (state, action: PayloadAction<number>) => {
      state.selectedIndex = action.payload;
    },
    resetSelectedIndex: (state) => {
      state.selectedIndex = 0; // 👈 mutate safely
    },
    setSelectDisbDetailIndex: (state, action: PayloadAction<number>) => {
      state.selectDisbDetailIndex = action.payload;
    },
    setProdcuctName: (state, action: PayloadAction<string>) => {
      state.productName = action.payload;
    },
    setQuickHelpInfoRoute: (state, action: PayloadAction<string>) => {
      state.quickHelpInfoRoute = action.payload;
    },
    setTabType: (state, action: PayloadAction<string>) => {
      state.tabType = action.payload;
    },
    hydrateTabType: (state, action: PayloadAction<string>) => {
      state.tabType = action.payload;
    },
    setAdditionalSummaryActiveTab: (state, action: PayloadAction<number>) => {
      state.additionalSummaryActiveTab = action.payload;
    },
    setAdditionalSummaryDocumentsComplete: (state, action: PayloadAction<boolean>) => {
      state.additionalSummaryDocumentsComplete = action.payload;
    },
    setAdditionalSummaryConsentComplete: (state, action: PayloadAction<boolean>) => {
      state.additionalSummaryConsentComplete = action.payload;
    },
  },
});

export const { setSelectedIndex, setProdcuctName, setSelectDisbDetailIndex, setQuickHelpInfoRoute, setTabType, hydrateTabType,setOpenFirstTimeOnlyPopup,setSummaryPageActiveTab,setApplicationStatus,resetSelectedIndex, setAdditionalSummaryActiveTab, setAdditionalSummaryDocumentsComplete, setAdditionalSummaryConsentComplete } = tabsSlice.actions;
export default tabsSlice.reducer;
